/// JobPanel: Container panel for the job management view.
/// Wraps JobList which provides filtering, selection, and complete/fail actions.

import { JobList } from "./jobs/JobList";

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function JobPanel() {
  return (
    <div className="flex flex-col h-full">
      <JobList />
    </div>
  );
}
